import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Context, LoadableSchema, Transitions } from "../../../types"

export const spv2TeacherOverallState: StateNodeConfig<
  Context,
  LoadableSchema,
  Transitions,
  BaseActionObject
> = {
  id: "sp_v2_teacher_overall_state",
  initial: "idle",
  states: {
    idle: {},
    loading: {}
  }
}
